/**
 * Shared Timezone Options for dropdowns
 * Keep in sync with /app/frontend/src/utils/timezone.js abbreviations.
 * Used by: Settings.jsx, ManageUsers.jsx
 */

export const TIMEZONE_OPTION_GROUPS = [
  {
    label: 'North America - United States',
    options: [
      { value: 'America/New_York', label: 'Eastern Time (EST/EDT)' },
      { value: 'America/Chicago', label: 'Central Time (CST/CDT)' },
      { value: 'America/Denver', label: 'Mountain Time (MST/MDT)' },
      { value: 'America/Phoenix', label: 'Arizona Time (MST - No DST)' },
      { value: 'America/Los_Angeles', label: 'Pacific Time (PST/PDT)' },
      { value: 'America/Anchorage', label: 'Alaska Time (AKST/AKDT)' },
      { value: 'Pacific/Honolulu', label: 'Hawaii Time (HST)' },
    ],
  },
  {
    label: 'North America - Canada',
    options: [
      { value: 'America/Toronto', label: 'Canada Eastern (EST/EDT)' },
      { value: 'America/Winnipeg', label: 'Canada Central (CST/CDT)' },
      { value: 'America/Regina', label: 'Saskatchewan (CST - No DST)' },
      { value: 'America/Edmonton', label: 'Canada Mountain (MST/MDT)' },
      { value: 'America/Vancouver', label: 'Canada Pacific (PST/PDT)' },
      { value: 'America/Halifax', label: 'Canada Atlantic (AST/ADT)' },
      { value: 'America/St_Johns', label: 'Newfoundland (NST/NDT)' },
    ],
  },
  {
    label: 'Europe - Western',
    options: [
      { value: 'Europe/London', label: 'UK - London (GMT/BST)' },
      { value: 'Europe/Dublin', label: 'Ireland - Dublin (GMT/IST)' },
      { value: 'Europe/Lisbon', label: 'Portugal - Lisbon (WET/WEST)' },
    ],
  },
  {
    label: 'Europe - Central',
    options: [
      { value: 'Europe/Paris', label: 'France - Paris (CET/CEST)' },
      { value: 'Europe/Berlin', label: 'Germany - Berlin (CET/CEST)' },
      { value: 'Europe/Rome', label: 'Italy - Rome (CET/CEST)' },
      { value: 'Europe/Madrid', label: 'Spain - Madrid (CET/CEST)' },
      { value: 'Europe/Amsterdam', label: 'Netherlands - Amsterdam (CET/CEST)' },
      { value: 'Europe/Brussels', label: 'Belgium - Brussels (CET/CEST)' },
      { value: 'Europe/Zurich', label: 'Switzerland - Zurich (CET/CEST)' },
      { value: 'Europe/Vienna', label: 'Austria - Vienna (CET/CEST)' },
      { value: 'Europe/Stockholm', label: 'Sweden - Stockholm (CET/CEST)' },
      { value: 'Europe/Copenhagen', label: 'Denmark - Copenhagen (CET/CEST)' },
      { value: 'Europe/Oslo', label: 'Norway - Oslo (CET/CEST)' },
      { value: 'Europe/Warsaw', label: 'Poland - Warsaw (CET/CEST)' },
      { value: 'Europe/Prague', label: 'Czech Republic - Prague (CET/CEST)' },
    ],
  },
  {
    label: 'Europe - Eastern',
    options: [
      { value: 'Europe/Athens', label: 'Greece - Athens (EET/EEST)' },
      { value: 'Europe/Helsinki', label: 'Finland - Helsinki (EET/EEST)' },
      { value: 'Europe/Bucharest', label: 'Romania - Bucharest (EET/EEST)' },
      { value: 'Europe/Sofia', label: 'Bulgaria - Sofia (EET/EEST)' },
      { value: 'Europe/Kiev', label: 'Ukraine - Kyiv (EET/EEST)' },
    ],
  },
  {
    label: 'Europe - Other',
    options: [
      { value: 'Europe/Moscow', label: 'Russia - Moscow (MSK)' },
      { value: 'Europe/Istanbul', label: 'Turkey - Istanbul (TRT)' },
    ],
  },
];

// Flat list for quick iteration
export const TIMEZONE_OPTIONS = TIMEZONE_OPTION_GROUPS.flatMap((g) => g.options);
